import React from 'react';
import {BrowserRouter, Router, Switch, Route} from "react-router-dom";
import Nav from './GoogleClone/homeComponents/Nav';
import SearchRes from './GoogleClone/searchPage/SeachRes';
import './GoogleClone/styles/design.css';
// import MyApp from './components/MyApp';
// import MyApp2 from './components/MyApp2';
// import Component1 from './propsTutorial/Component1';
// import Component2 from './propsTutorial/Component2';
// import Lesson1 from './stateLesson/Lesson1';
// import Counter from './stateLesson/Counter';
// import Nimadir from './lifecycleLesson/Nimadir';
// import Backend from './APITutorial/Backend';
// import SassTutorial from './sassTutorial/SassTutorial';

function App() {
  return (
    <>
        <BrowserRouter>
          <Switch>
            <Route path="/" exact component={Nav} />
            <Route path="/search" component={SearchRes} />
          </Switch>
       </BrowserRouter>
    </>
  );
}

export default App;